import { __decorate } from "tslib";
import PasswordViewable from '@/components/PasswordViewable.vue';
import ButtonLoading from '@/components/ButtonLoading.vue';
import { Component } from "vue-property-decorator";
import Vue from 'vue';
let Login = class Login extends Vue {
    data = {
        email: '',
        password: '',
        strategy: 'local',
    };
    loading = false;
    errors = null;
    get emailFieldPlaceholder() {
        return 'company@' + process.env.VUE_APP_DOMAIN || '32desk.com';
    }
    login() {
        this.errors = null;
        this.loading = true;
        this.$store.dispatch('auth/authenticate', this.data).then(data => {
            this.$router.push({ name: 'appointments' });
            this.loading = false;
        }).catch(error => {
            this.errors = error.message;
            this.loading = false;
        });
    }
};
Login = __decorate([
    Component({
        name: 'login',
        components: {
            PasswordViewable,
            ButtonLoading
        },
    })
], Login);
export default Login;
